<template lang="pug">
  v-dialog(v-model="show" persistent scrollable fullscreen)
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-form.text-center(ref="form" v-model="isFormValid" :lazy-validation="true" :disabled="isSaveInProgress" @submit.prevent="onFormSubmit()")
      v-card(v-if="$vuetify.breakpoint.mdAndUp")
        v-card-text
          v-row.ma-0(justify="center")
            v-card.text-center.ma-0.pa-0(flat max-width="1000px" width="1000px" :loading="isLoading")
              v-card-title.text-center.title.justify-center(justify="center") {{ $t('permalinkPage.applicationTitle') }}
              v-card-subtitle.text-center.title(v-if="config.enabled_customers.length === 1") {{getCustomerName}}
              v-card-text.text-center.font-weight-bold( align="center" justify="center") {{config.description}}
              v-row.ma-0
                v-col(cols="12" md="6")
                  v-text-field(
                    v-model="currentFirstName"
                    :label="$t('permalinkPage.firstName')" outlined prepend-icon="fas fa-user" required
                  :dense="$vuetify.breakpoint.mdAndUp" :rules="givenNameRules")
                v-col(cols="12" md="6")
                  v-text-field(
                    v-model="currentFamilyName"
                    :label="$t('permalinkPage.familyName')" outlined required prepend-icon="fas fa-user"
                  :dense="$vuetify.breakpoint.mdAndUp" :rules="familyNameRules")

              v-row.ma-0
                v-col(cols="12" md="6")
                  v-text-field(
                    v-model="currentEmail"
                    :label="$t('permalinkPage.email')" outlined prepend-icon="fas fa-envelope"
                    :dense="$vuetify.breakpoint.mdAndUp" :rules="emailRules")
                v-col(cols="12" md="6")
                  v-text-field(
                    v-model="currentPhoneNumber"
                    :label="$t('permalinkPage.phone')" outlined prepend-icon="fas fa-phone" :rules="currentPhoneNumberRules"
                    :dense="$vuetify.breakpoint.mdAndUp")
              v-row.ma-0
                v-col.pb-0(cols="12" md="6" v-if="config.enabled_customers.length > 1 || config.enabled_customers.length == 0")
                  v-select(
                    v-model="currentCustomer"
                    append-icon="fas fa-chevron-down" :label="getCustomerTitle" prepend-icon="fas fa-user-tie"
                    outlined item-value="id" item-text="name" return-object :rules="currentCustomerRules"
                    :items="filteredCustomerList" :dense="$vuetify.breakpoint.mdAndUp" :loading="isLoading")
                v-col.pb-0(cols="12" md="6")
                  v-select(v-if="config.enabled_boarder_group.length > 1 || config.enabled_boarder_group.length == 0"
                    v-model="currentBoarderGroup"
                    append-icon="fas fa-chevron-down" :label="getBoarderGroupTitle"
                    outlined item-value="id" item-text="name" return-object prepend-icon="fas fa-house-user"
                    :items="filteredBoarderGroupList" :disabled="isBoarderGroupSelectorDisabled"
                    :dense="$vuetify.breakpoint.mdAndUp" :loading="isLoading" :rules="currentBoarderGroupRules" )
              v-row.ma-0
                v-col.pa-0.pl-3(cols="12" md="6")
                  v-checkbox(on-icon="fas fa-check-square" off-icon="fal fa-square"
                    :label="$t('permalinkPage.alreadyHaveAccountLabel')" @change="" v-model="checkBox")
              v-row.ma-0
                v-spacer
                v-btn(color="primary" :disabled="!isFormValid || isLoading" :loading="isSaveInProgress" type="submit") {{ $t('permalinkPage.submitApplicationButtonLabel') }}
      v-card(v-else)
        v-card-title.text-center.title.justify-center(justify="center") {{ $t('permalinkPage.applicationTitle') }}
        v-card-subtitle.text-center.title(v-if="config.enabled_customers.length === 1") {{getCustomerName}}
        v-card-text.text-center.font-weight-bold( align="center" justify="center" ) {{config.description}}
          v-row.ma-0.mt-4
            v-col.pa-0(cols="12" md="6")
              v-text-field(
                v-model="currentFirstName"
                :label="$t('permalinkPage.firstName')" outlined prepend-icon="fas fa-user" required
              :dense="$vuetify.breakpoint.mdAndUp" :rules="givenNameRules")
            v-col.pa-0(cols="12" md="6")
              v-text-field(
                v-model="currentFamilyName"
                :label="$t('permalinkPage.familyName')" outlined required prepend-icon="fas fa-user"
                :dense="$vuetify.breakpoint.mdAndUp" :rules="familyNameRules")
          v-row.ma-0
            v-col.pa-0(cols="12" md="6")
              v-text-field(
                v-model="currentEmail"
                :label="$t('permalinkPage.email')" outlined prepend-icon="fas fa-envelope"
                :dense="$vuetify.breakpoint.mdAndUp" :rules="emailRules")
            v-col.pa-0(cols="12" md="6")
              v-text-field(
                v-model="currentPhoneNumber"
                :label="$t('permalinkPage.phone')" outlined prepend-icon="fas fa-phone"
                :dense="$vuetify.breakpoint.mdAndUp" :rules="currentPhoneNumberRules")
          v-row.ma-0
            v-col.pa-0(cols="12" md="6")
              v-select(v-if="config.enabled_customers.length == 0 || config.enabled_customers.length >=0 && config.enabled_boarder_group.length > 1"
                v-model="currentCustomer"
                append-icon="fas fa-chevron-down" :label="getCustomerTitle" prepend-icon="fas fa-user-tie"
                outlined item-value="id" item-text="name" return-object :rules="currentCustomerRules"
                :items="filteredCustomerList" :dense="$vuetify.breakpoint.mdAndUp" :loading="isLoading")
            v-col.pa-0(cols="12" md="6")
              v-select(v-if="config.enabled_boarder_group.length == 0 || config.enabled_boarder_group.length > 1"
                v-model="currentBoarderGroup"
                append-icon="fas fa-chevron-down" :label="getBoarderGroupTitle"
                outlined item-value="id" item-text="name" return-object prepend-icon="fas fa-house-user"
                :items="filteredBoarderGroupList" :disabled="isBoarderGroupSelectorDisabled"
                :dense="$vuetify.breakpoint.mdAndUp" :loading="isLoading" :rules="currentBoarderGroupRules" )
            v-row.ma-0
              v-col.pa-0(cols="12" md="6")
                v-checkbox(on-icon="fas fa-check-square" off-icon="fal fa-square"
                  :label="$t('permalinkPage.alreadyHaveAccountLabel')" @change="" v-model="checkBox")
        v-card-actions(v-if="$vuetify.breakpoint.smAndDown")
          v-row.ma-0
            v-spacer
            v-btn(color="primary" :disabled="!isFormValid || isLoading" :loading="isSaveInProgress" type="submit") {{ $t('permalinkPage.submitApplicationButtonLabel') }}


</template>

<script lang="ts">
import Vue from 'vue'

import {Component, Prop, Watch} from 'vue-property-decorator'
import {Action} from "vuex-class";
import {
  CREATE_NEW_REQUEST,
  FETCH_BOARDER_DATA,
} from "@/store/action-types";
import {NewRequestPayload} from "@/types/payload";
import SmartLink from "@/model/SmartLink";
import CustomerWithGroup from "@/model/CustomerWithGroup";
import {BoarderGroupsResponse, CustomerResponse} from "@/types/service-response";
import {TranslateResult} from "vue-i18n";
import i18n from "@/plugins/i18n";

function valueIsRequired(v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function validateEmail(v: string): boolean | TranslateResult {
  if (v) {
    return /.+@.+\..+/.test(v) || i18n.t('validation.emailMustBeValid')
  }

  return true
}

@Component({

})export default class BoarderFoodOrderingRequest extends Vue {
  $refs!: {
    form: Vue & { validate(): boolean }
  }

  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: true}) readonly smartLink!: SmartLink

  @Action(CREATE_NEW_REQUEST) createNewRequest!: { (payload: NewRequestPayload): Promise<void> }
  @Action(FETCH_BOARDER_DATA) fetchData!: ({ (payload: string): Promise<CustomerWithGroup[]> })

  private isFormValid: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: TranslateResult = ''
  private isSaveInProgress: boolean = false
  private isLoading: boolean = false
  private currentFirstName: string = ''
  private currentFamilyName: string = ''
  private currentEmail: string = ''
  private currentPhoneNumber: string = ''
  private currentCustomer: any = null
  private currentBoarderGroup: any = null
  private boarderGroup: BoarderGroupsResponse[] = []
  private boarderData: any[] = []
  private isBoarderGroupSelectorDisabled: boolean = true
  private customer: any[] = []
  private checkBox: boolean = false


  private givenNameRules = [
    valueIsRequired
  ]

  private familyNameRules = [
    valueIsRequired
  ]

  private emailRules = [
    valueIsRequired,
    validateEmail
  ]

  private currentCustomerRules = [
    valueIsRequired
  ]

  private currentPhoneNumberRules = [
    valueIsRequired
  ]

  private currentBoarderGroupRules = [
    valueIsRequired
  ]

  @Watch('currentCustomer')
  watchCurrentCustomer (newVal: CustomerResponse): void {
    if(newVal) {
      this.currentCustomer = newVal
      this.currentBoarderGroup = null
    }
  }

  // Smart link configuration with defaults for keys that older links may not
  // have; a missing enabled_customers/enabled_boarder_group means "no
  // restriction", same as an empty array.
  get config(): any {
    const cfg = this.smartLink.configuration?.[0] ?? {}
    return {
      ...cfg,
      enabled_customers: cfg.enabled_customers ?? [],
      enabled_boarder_group: cfg.enabled_boarder_group ?? [],
    }
  }

  get getCustomerTitle (): string {
    if(this.config.customers_label) {
      return this.config.customers_label
    } else {
      return this.$t('permalinkPage.customerLabel').toString()
    }

  }

  get getBoarderGroupTitle (): string {
    if(this.config.boarder_group_label) {
    return this.config.boarder_group_label
    } else {
      return this.$t('permalinkPage.boarderGroupLabel').toString()
    }
  }


  get filteredBoarderGroupList() {
    this.boarderGroup = []
    if(this.currentCustomer ) {
      if (this.config.enabled_customers.length > 0) {
        this.isBoarderGroupSelectorDisabled = false
        const data: any | undefined = this.boarderData.find((item: CustomerWithGroup) => item.customer.id === this.currentCustomer.id)
        if (data) {
          let foundData: any | null = null
          this.config.enabled_boarder_group.forEach((i: any) => {
            foundData = data.boarderGroups.find((b: BoarderGroupsResponse) => b.id.toString() === i.replace('/api/boarder-group/', ''))
            if (foundData) {
              this.boarderGroup.push(foundData)
            }
          })
        }
      } else {
        this.isBoarderGroupSelectorDisabled = false
        const data: any | undefined = this.boarderData.find((item: CustomerWithGroup) => item.customer.id === this.currentCustomer.id)
        if (data) {
          let foundData: any | null = null
          this.boarderData.forEach((a: any) => {
            a.boarderGroups.forEach((i: any) => {
              foundData = data.boarderGroups.find((b: BoarderGroupsResponse) => b.id == i.id)
              if (foundData) {
                this.boarderGroup.push(foundData)
              }
            })
            })
      }
      }

    } else if(this.config.enabled_customers.length == 1) {
      this.isBoarderGroupSelectorDisabled = false
      const id = this.config.enabled_customers[0].replace('/api/customer/', '')
      const data: any | undefined = this.boarderData.find((item: CustomerWithGroup) => item.customer.id == id)
      if(data) {
        data.boarderGroups.forEach((i: BoarderGroupsResponse) => {
          this.boarderGroup.push(i)
        })
      }
    } else{
      this.isBoarderGroupSelectorDisabled = true
      this.boarderGroup = []
    }
    return this.boarderGroup
  }

  get filteredCustomerList(): any[] {
    let foundData: any[] = []
    let id: any | null = null
    if(this.config.enabled_customers.length > 0) {
      this.config.enabled_customers.forEach((item: any) => {
        id = item.replace('/api/customer/', '')
        foundData = this.boarderData.filter((g) => g.customer.id == id)
        foundData.forEach((a: any) => {
          this.customer.push(a.customer)
        })
      })
    } else {
      this.boarderData.forEach((a: any) => {
        this.customer.push(a.customer)
      })
    }

    return this.customer
  }

  get getCustomerName () {
      let test: any | null = null
      let id = this.config.enabled_customers[0].replace('/api/customer/', '')
      const foundData = this.boarderData.filter((g) => g.customer.id == id)
      if(foundData ) {
        foundData.forEach((a: any) => {
          test = a.customer.name
        })

      }
      return test
  }

  onFormSubmit(): void {
    if((this.$refs.form.validate())) {
      this.onCreateNewRequest()
    }
  }

  async onCreateNewRequest(): Promise<void> {
    let customerId = this.config.enabled_customers[0]
    let groupId = this.config.enabled_boarder_group[0]
    let payload: NewRequestPayload = {
      tenant: this.smartLink.tenant,
      kind: `/api/request-kind/onboarding`,
      data: {
        firstName: this.currentFirstName,
        familyName: this.currentFamilyName,
        email: this.currentEmail,
        phoneNumber: this.currentPhoneNumber,
        customer: this.config.enabled_customers.length == 1 ? customerId : `/api/customer/${this.currentCustomer.id}`,
        boarderGroup:this.config.enabled_boarder_group.length == 1 ? groupId :`/api/boarder-group/${this.currentBoarderGroup.id}`,
        alreadyHaveAccount: this.checkBox
      }
    }
    try {
      this.isSaveInProgress = true
      await this.createNewRequest(payload)

    } catch (e) {
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('permalinkPage.createDataError')
      this.showSnackBar = true

    } finally {
      this.isSaveInProgress = false
      this.$emit('close')
    }
  }


  async fetchBoarderData():Promise<void> {
    const payload: string = this.smartLink.tenant

    try {
      this.isLoading = true
      const response = await this.fetchData(payload)
      this.boarderData = response
      this.isLoading = false
    } catch (e) {
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('orderPage.fetchDataError')
      this.showSnackBar = true
    }
  }

  mounted() {
    this.fetchBoarderData()
    this.isFormValid = false

  }

}
</script>

<style lang="stylus" scoped>

</style>
